import React, { Component } from "react";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as supportActions from "../../redux/actions/support";
import SupportIssuesTable from "../../components/support/SupportIssuesTable";
import { Loading, Button } from "../../components/widgets/index";
import Page from "../../components/layout/Page";
import Permissions from "../../permissions";
import SupportIssuesSearch from "../../components/support/SupportIssuesSearch";

const mapStateToProps = state => ({
  zendeskTickets: state.support.zendeskTickets,
  supportFilter: state.support.filter,
});

const mapDispatchToProps = dispatch => {
  return {
    supportActions: bindActionCreators(supportActions, dispatch),
  };
};

class SupportIssues extends Component {
  constructor(props) {
    super(props);

    const filter = props.supportFilter;

    this.state = {
      showSearch: !!filter.subjectOrAddress || !!filter.ticketStatus || !!filter.ticketPriority,
    };
  }

  componentDidMount() {
    this.props.supportActions.fetchZendeskTickets();
  }

  showSearch = () => {
    this.setState({
      showSearch: true,
    });
  };

  hideSearch = () => {
    this.props.supportActions.clearSupportFilter();
    this.setState({
      showSearch: false,
    });
  };

  filterTickets = tickets => {
    const supportFilter = this.props.supportFilter;

    let filteredTickets = tickets;

    if (supportFilter.ticketStatus) {
      if (supportFilter.ticketStatus === "Open") {
        filteredTickets = filteredTickets.filter(
          ticket =>
            ticket.status === "open" || ticket.status === "pending" || ticket.status === "new"
        );
      } else if (supportFilter.ticketStatus === "Resolved") {
        filteredTickets = filteredTickets.filter(
          ticket => ticket.status === "solved" || ticket.status === "closed"
        );
      }
    }

    if (supportFilter.ticketPriority) {
      if (supportFilter.ticketPriority === "High") {
        filteredTickets = filteredTickets.filter(ticket => ticket.priority === "High");
      } else if (supportFilter.ticketPriority === "Normal") {
        filteredTickets = filteredTickets.filter(ticket => ticket.priority === "Normal");
      } else if (supportFilter.ticketPriority === "Low") {
        filteredTickets = filteredTickets.filter(ticket => ticket.priority === "Low");
      }
    }

    const searchTerm = supportFilter.subjectOrAddress;
    if (searchTerm) {
      let searchLower = searchTerm.toLowerCase();
      filteredTickets = filteredTickets.filter(
        ticket =>
          `${ticket.subject} ${ticket.ticketId}`.toLowerCase().indexOf(searchLower) >= 0 ||
          ticket.address.toLowerCase().indexOf(searchLower) >= 0
      );
    }

    filteredTickets.sort((a, b) => {
      if (a.updatedAtTimestamp < b.updatedAtTimestamp) return 1;
      if (a.updatedAtTimestamp > b.updatedAtTimestamp) return -1;
      return 0;
    });

    return filteredTickets;
  };

  render() {
    if (!this.props.zendeskTickets) {
      return <Loading />;
    }

    const tickets = this.filterTickets(Object.values(this.props.zendeskTickets));
    return (
      <Page permission={Permissions.fleet.node.any}>
        <Page.Header title="Support Issues">
          <Page.Header.Actions>
            {this.state.showSearch ? (
              <Button
                id="clear-support-issues-search"
                type="secondary"
                icon="times"
                onClick={this.hideSearch}
              >
                Clear Filter
              </Button>
            ) : (
              <Button
                id="enable-support-issues-search"
                type="secondary"
                icon="search"
                onClick={this.showSearch}
              >
                Filter List
              </Button>
            )}
            <Button
              id="support-issues-new"
              type="primary"
              to="/support-issues/issues/new"
              icon="plus"
            >
              Create Support Ticket
            </Button>
          </Page.Header.Actions>
        </Page.Header>
        <Page.SearchFields visible={this.state.showSearch}>
          <SupportIssuesSearch
            onFilterFieldChange={this.props.supportActions.updateSupportFilter}
            subjectOrAddress={this.props.supportFilter.subjectOrAddress}
            ticketStatus={this.props.supportFilter.ticketStatus}
            ticketPriority={this.props.supportFilter.ticketPriority}
          />
        </Page.SearchFields>
        <Page.Content>
          <SupportIssuesTable tickets={tickets} history={this.props.history} />
        </Page.Content>
      </Page>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SupportIssues));
